import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import {
  fetchStatutoryBalances,
  recordStatutoryPayment,
  fetchStatutoryPaymentHistory
} from "./statutorySettlementThunk";
import { IStatutorySettlementSliceState } from "../../utils/statutorySettlement.types";

const initialState: IStatutorySettlementSliceState = {
  balances: null,
  payments: [],
  status: ApiStatus.IDLE,
  balancesStatus: ApiStatus.IDLE,
  paymentStatus: ApiStatus.IDLE,
  historyStatus: ApiStatus.IDLE,
  errorMessage: ''
};

const statutorySettlementSlice = createSlice({
  name: 'statutorySettlement',
  initialState: initialState,
  reducers: {
    resetPaymentStatus: (state) => {
      state.paymentStatus = ApiStatus.IDLE;
      state.errorMessage = '';
    },
    clearBalances: (state) => {
      state.balances = null;
      state.balancesStatus = ApiStatus.IDLE;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Statutory Balances
      .addCase(fetchStatutoryBalances.pending, (state) => {
        state.balancesStatus = ApiStatus.LOADING;
      })
      .addCase(fetchStatutoryBalances.fulfilled, (state, action) => {
        state.balancesStatus = ApiStatus.SUCCESS;
        state.balances = action.payload;
        state.errorMessage = '';
      })
      .addCase(fetchStatutoryBalances.rejected, (state, action) => {
        state.balancesStatus = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
        toast.error('Failed to fetch statutory balances');
      })

      // Record Statutory Payment
      .addCase(recordStatutoryPayment.pending, (state) => {
        state.paymentStatus = ApiStatus.LOADING;
      })
      .addCase(recordStatutoryPayment.fulfilled, (state, action) => {
        state.paymentStatus = ApiStatus.SUCCESS;
        state.payments = [action.payload, ...state.payments];
        state.errorMessage = '';
        toast.success('Statutory payment recorded successfully');
      })
      .addCase(recordStatutoryPayment.rejected, (state, action) => {
        state.paymentStatus = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
        toast.error(action.error.message || 'Failed to record statutory payment');
      })

      // Fetch Statutory Payment History
      .addCase(fetchStatutoryPaymentHistory.pending, (state) => {
        state.historyStatus = ApiStatus.LOADING;
      })
      .addCase(fetchStatutoryPaymentHistory.fulfilled, (state, action) => {
        state.historyStatus = ApiStatus.SUCCESS;
        state.payments = action.payload;
        state.errorMessage = '';
      })
      .addCase(fetchStatutoryPaymentHistory.rejected, (state, action) => {
        state.historyStatus = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
        toast.error('Failed to fetch statutory payment history');
      });
  }
});

export const { resetPaymentStatus, clearBalances } = statutorySettlementSlice.actions;
export default statutorySettlementSlice.reducer;
